import { Box, Flex, Heading } from '@radix-ui/themes';

function Storenvy() {
    return (
        <>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#78C8A7' }}>
                    FEATURED COLLECTIONS
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="wrap" mt="4">
                    <Box style={{ aspectRatio: '657/500', maxHeight: 500, maxWidth: 657, overflow: 'hidden' }}>
                        <img
                            src={'/images/FeaturedCollection.png'}
                            alt="Featured Collection"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Box pl={{ xl: '6' }} maxWidth={{ xl: '50%' }} style={{ alignSelf: 'center' }}>
                        <Heading as="h4" size="8" weight="regular">
                            A series spotlighted on storenvy.com that depicts multiple collections of merchandise grouped together with
                            common themes. Each assortment of products is given its own period of time on the main page of the website.
                            Inspiration for each design in turn is derived from the content or theme of the collection.
                        </Heading>
                    </Box>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#78C8A7' }}>
                    SOCIAL MEDIA
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="wrap" mt="4">
                    <Flex maxWidth={{ initial: '100%', xl: '60%' }} style={{ maxHeight: 700 }}>
                        <Flex direction="column" gap="4" justify="between" height={{ xl: '700px' }}>
                            <Heading as="h4" size="8" weight="regular">
                                Samples of a large series of Twitter and Instagram posts. This collection consists of approximately two
                                hundred posts sent out over a period of three months, with five to four on average published daily. Each
                                piece depicts a featured product along with a tagline promoting the merchandise and creator.
                            </Heading>
                            <Box
                                style={{
                                    aspectRatio: '664/400',
                                    maxHeight: 450,
                                    maxWidth: 747,
                                    overflow: 'hidden',
                                    border: '1px solid #000',
                                }}
                            >
                                <img
                                    src={'/images/GreekPins.png'}
                                    alt="Greek Pins"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                />
                            </Box>
                        </Flex>
                    </Flex>
                    <Box
                        maxWidth={{ initial: '100%', lg: '40%' }}
                        style={{ aspectRatio: '522/700', maxHeight: 700, overflow: 'hidden' }}
                    >
                        <img
                            src={'/images/CatStands.png'}
                            alt="Cat Stands"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#78C8A7' }}>
                    PINTEREST
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="wrap" mt="4">
                    <Box style={{ aspectRatio: '1/1', maxHeight: 500, maxWidth: 500, overflow: 'hidden' }}>
                        <img
                            src={'/images/NewBrands.png'}
                            alt="New Brands"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Box style={{ aspectRatio: '888/500', maxHeight: 500, maxWidth: 888, overflow: 'hidden' }}>
                        <img
                            src={'/images/PinterestShopUpdate.png'}
                            alt="Pinterest Shop Update"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                </Flex>
                <Box flexGrow="1" pt={{ initial: '4', xl: '6' }} style={{ alignSelf: 'center' }}>
                    <Heading as="h4" size="8" weight="regular">
                        Pinterest collection title cards and page heading banners. Each collection card features either one or a multitude
                        of sample products from the collection. The banners are coordinated according to the seasonal collections and thus
                        rely on parallel color palettes. Additionally the products of the collection are presented within the tile pattern
                        created using the Storenvy logo.
                    </Heading>
                </Box>
            </Box>
        </>
    );
}

export default Storenvy;
